/**
 * Created by Michał Stawski on 2018-01-10.
 */
import React from 'react';
import { DatePicker } from '@material-ui/pickers'

export const DatePickerReduxWrapper = props => {
  const {
    showErrorsInline,
    input: {onChange, value},
    meta: {touched, error},
    inputProps,
    inputRef,
    ...other
  } = props;
  const showError = showErrorsInline || touched;

  return (
    <DatePicker
      error={!!(showError && error)}
      helperText={showError && error}
      value={value}
      onChange={onChange}
      {...other}
    />
  )
};
